import { useEffect, useState } from 'react';
import ServiceCard from '../ServiceCard/ServiceCard';
import CustomIcon from '../CustomIcon/CustomIcon';
import Filters from '../Filters/Filters';
import { serviceGet } from '../helpers/utils';

const initialFilterStates = {
  show: false,
  text: '',
  color: '',
  icon: '',
  tipoFiltro: '',
  descriptionFilter: '',
};

const filterDataIntialState = {
  Departamento: { label: null, value: null },
  Ciudad: { label: null, value: null },
};

function RoutesContainer({ title, description, icon, serviceList }) {
  const [filter, setFilter] = useState(initialFilterStates);
  const [ciudadesDepartamentosList, setCiudadesDepartamentosList] = useState([]);
  const [departamentosList, setDepartamentosList] = useState([]);
  const [ciudadesList, setCiudadesList] = useState([]);
  const [filterData, setFiltersData] = useState(filterDataIntialState);

  function agruparPorDepto(resultado) {
    const agrupaciones = resultado.reduce((acc, item) => {
      const depto = item.Valores.find((v) => v.NombreInternoCampo === 'DEPTO')?.Valor;
      const title = item.Valores.find((v) => v.NombreInternoCampo === 'Title')?.Valor;
      if (depto && title) {
        if (!acc[depto]) {
          acc[depto] = [];
        }
        acc[depto].push(title);
      }

      return acc;
    }, {});

    return Object.entries(agrupaciones).map(([depto, titles]) => ({
      Departamento: depto,
      Ciudades: titles,
    }));
  }

  const getCiudadesDepartamentos = () => {
    serviceGet(
      {
        Accion: 'GET',
        Lista: 'Ciudad',
        UrlSitio: window.location.origin + '/salud/',
        Vista: ['Title', 'DEPTO'],
        Campos: {
          Query: [{}],
        },
      },
      'UtilidadSharepointGet',
      'ServicioTransar.svc',
    ).then((data) => {
      if (data.ResponseCode === 200 && data.ResponseDetail === 'Ok') {
        const listCiudadesDepratamentos = agruparPorDepto(data.Result.Resultado);
        setCiudadesDepartamentosList(listCiudadesDepratamentos);
        setDepartamentosList(
          listCiudadesDepratamentos.map((item) => ({
            label: item.Departamento,
            value: item.Departamento,
          })),
        );
      }
    });
  };

  const handleSelect = (value, name) => {
    setFiltersData((prevState) => ({ ...prevState, [name]: value }));
  };

  const onDepartamentoSelect = (departamento) => {
    handleSelect(departamento, 'Departamento');
    handleSelect(null, 'Ciudad');
    const filterDepto = ciudadesDepartamentosList.filter((elm) => elm.Departamento === departamento?.value);

    setCiudadesList(
      filterDepto[0].Ciudades.map((item) => ({
        label: item,
        value: item,
      })),
    );
  };

  useEffect(() => {
    getCiudadesDepartamentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleFilters = ({ text, color, icon, show, tipoFiltro, descriptionFilter }) => {
    console.log('descriptionFilter', descriptionFilter);
    setFilter({
      show,
      text,
      color,
      icon,
      tipoFiltro,
      descriptionFilter,
    });
  };

  const volverHandler = () => {
    toggleFilters(initialFilterStates);
    setFiltersData(filterDataIntialState);
    setCiudadesList([]);
  };

  return (
    <div>
      <div className="routesContainer-header">
        <div dangerouslySetInnerHTML={{ __html: icon }} />
        <div>
          <h3 className="routesContainer-header-text">{title}</h3>
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>
      </div>
      {filter.show && (
        <div className="volver-btn-container">
          <button type="button" className="volver-btn btn btn-link" onClick={volverHandler}>
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
            {parseText('rutasServicios.btns.volver')}
          </button>
        </div>
      )}
      <div className="service-cards-container">
        {filter.show ? (
          <div>
            <div className="filters-header">
              <CustomIcon className="icon-mask" icon={filter.icon} color={filter.color} />
              <h4>{filter.text}</h4>
            </div>
            <Filters
              onDepartamentoSelect={onDepartamentoSelect}
              departamentosList={departamentosList}
              ciudadesList={ciudadesList}
              onFilterSelect={handleSelect}
              filterData={filterData}
              tipoFiltro={filter.tipoFiltro}
            />
          </div>
        ) : (
          <div className="row service-cards-grid">
            {serviceList.map((item) => (
              <ServiceCard
                text={item.CSNombreCertificadoText}
                icon={`${window.location.origin}${item.CSURLCertificadoText}`}
                color={item.Color}
                onClick={toggleFilters}
                tipoFiltro={item.TipoFiltro}
                descriptionFilter={item.CSDescripcionRutasext}
              />
            ))}
          </div>
        )}
        <div className="filter-divider" style={{ backgroundColor: filter.color }}></div>
      </div>
      <div className="service-description" dangerouslySetInnerHTML={{ __html: filter.descriptionFilter }} />
    </div>
  );
}

export default RoutesContainer;
